import { Stack, Typography } from "@mui/material";
import React, { useCallback } from "react";

export type OTPFieldsProps = {
	value: string;
	disabled?: boolean;
	helperText?: string;
	error?: boolean;
	onChange: (value: string) => void;
	onFilled?: () => void;
};
const OTP_LENGTH = 6;

const OTPFields = (props: OTPFieldsProps) => {
	const inputsRef = React.useRef<HTMLInputElement[]>([]);

	const [value, setValue] = React.useState<string[]>(Array(OTP_LENGTH).fill(""));
	const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
		e.target.select();
	}, []);

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>, index) => {
			if (e.key === "Backspace") {
				if (index === 0) {
					return;
				}
				if (value[index] === "" && inputsRef.current[index - 1]) {
					inputsRef.current[index - 1].focus();
				}
				return;
			}
			if (e.key === "ArrowLeft") {
				if (inputsRef.current[index - 1]) {
					inputsRef.current[index - 1].focus();
				}
				return;
			}
			// e.target.select();
			inputsRef.current[index].select();
		},
		[value],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>, index) => {
			const val = e.target.value;
			const newValues = [...value];
			newValues[index] = val.toUpperCase();
			setValue(newValues);
			if (val !== "") {
				if (index === OTP_LENGTH - 1) {
					props.onChange(newValues.join(""));
				}
				// if value length already 6, then call onComplete
				if (newValues.join("").length === OTP_LENGTH) {
					props.onFilled && props.onFilled();
				}
				if (!inputsRef.current[index + 1]) return;
				inputsRef.current[index + 1].focus();
			}
		},
		[value, props],
	);

	const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
		e.preventDefault();
		if (e.clipboardData) {
			const pastedData = e.clipboardData.getData("text");
			const newValues = [...value];
			for (let i = 0; i < OTP_LENGTH; i++) {
				newValues[i] = pastedData[i];
			}

			setValue(newValues);
			props.onChange(newValues.join(""));
			if (newValues.join("").length === OTP_LENGTH) {
				props.onFilled && props.onFilled();
			}
		}
	};

	return (
		<Stack>
			<div
				onPaste={handlePaste}
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					gap: 8,
					maxWidth: "100%",
				}}
			>
				{Array.from({ length: OTP_LENGTH }).map((_, index) => (
					<input
						style={{
							borderRadius: "8px",
							border: `2px solid ${props.error ? "#FF0000" : "#E5E7EB"}`,
							background: "#F2F2F2",
							width: "100%",
							height: "80px",
							flex: 1,
							textAlign: "center",
							fontSize: "32px",
						}}
						id={`otp_field_${index}`}
						key={index}
						type="text"
						value={value[index]}
						name={index.toString()}
						autoComplete="one-time-code"
						maxLength={1}
						ref={(el) => (inputsRef.current[index] = el as HTMLInputElement)}
						onKeyDown={(e) => handleKeyDown(e, index)}
						onChange={(e) => handleChange(e, index)}
						onFocus={handleFocus}
					/>
				))}
			</div>
			{props.error && (
				<Typography variant="caption" color={"error"} style={{ fontWeight: "normal", fontSize: 14 }}>
					{props.helperText}
				</Typography>
			)}
		</Stack>
	);
};

export default OTPFields;
